<template>
    <taskDetailCom v-if="display">
        <taskDetailComItem title="基础信息" >
            <div class="row">
                <div class="column">
                    <div class="item">
                        <div class="key">项目名称</div>
                        <div class="value">{{detailData.am_project_info.name}}</div>
                    </div>
                </div>
                <div class="column">
                    <div class="item">
                        <div class="key">翻译类型</div>
                        <div class="value">{{detailData.am_project_info.trans_type}}</div>
                    </div>
                </div>
                <div class="column">
                    <div class="item">
                        <div class="key">交稿时间</div>
                        <div class="value">{{detailData.am_project_info.submission_time}}</div>
                    </div>
                </div>
                <div class="column">
                    <div class="item">
                        <div class="key">创建时间</div>
                        <div class="value">{{detailData.am_project_info.create_time}}</div>
                    </div>
                </div>
                <div class="column">
                    <div class="item">
                        <div class="key">客户经理</div>
                        <div class="value">{{detailData.am_project_info.manager_info.fullname}}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="column">
                    <div class="item">
                        <div class="key">备注</div>
                        <div class="value">{{detailData.am_project_info.remarks}}</div>
                    </div>
                </div>
            </div>

            <div v-for="item in detailData.pm_project_info" :key="item.id">
                <div class="row">
                    <div class="column">
                        <div class="item">
                            <div class="key">项目任务名称</div>
                            <div class="value">{{item.name}}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">字数</div>
                            <div class="value">
                                {{item.page_or_words.number}}{{item.page_or_words.kind=='Page'?'页':'字'}}
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">交稿时间</div>
                            <div class="value">{{item.submission_time}}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">创建时间</div>
                            <div class="value">{{item.create_time}}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">项目经理</div>
                            <div class="value">{{item.manager_info.fullname}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="column">
                        <div class="item">
                            <div class="key">统稿人</div>
                            <div class="value">{{detailData.manager_info.fullname}}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">备注</div>
                            <div class="value">{{item.remarks}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-for="(item,index) in detailData.trans_project_info" :key="item.id">
                <div class="row">
                    <div class="column">
                        <div class="item">
                            <div class="key">译员任务名称</div>
                            <div class="value">{{item.name}}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">字数</div>
                            <div class="value">{{item.chars_number}}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">交稿时间</div>
                            <div class="value">{{item.submission_time}}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">创建时间</div>
                            <div class="value">{{item.create_time}}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">状态</div>
                            <div class="value">{{jobStatus[item.current_state]}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="column">
                        <div class="item">
                            <div class="key">译员</div>
                            <div class="value">{{item.manager_info ? item.manager_info.fullname : ''}}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">审校</div>
                            <div class="value">
                                <span v-for="re in item.reviewer_infos" :key="re.user_id">{{re.fullname}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">是否翻译完毕</div>
                            <div class="value">{{detailData.trans_project_info.had_complete?'是':'否'}}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="key">备注</div>
                            <div class="value">{{item.remarks}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </taskDetailComItem>

        <taskDetailComItem title="需统稿的文件">
            <taskDetailTranslatorFileListItem :file-data="detailData.project_files" label-name="任务文件"/>
        </taskDetailComItem>

        <taskDetailComItem title="提交统稿文件">
            <taskDetailTranslatorFileListItem :file-data="detailData.submit_files" label-name="任务文件"/>
        </taskDetailComItem>
    </taskDetailCom>
    <p v-else>加载中...</p>
</template>

<script>
    import taskDetailCom from "../../components/task/taskDetailCom";
    import taskDetailComItem from "../../components/task/taskDetailComItem";
    import taskDetailTranslatorFileListItem from "../../components/task/taskDetailTranslatorFileListItem";

    import {jobDetail} from "../../api/translator";
    import {jobStatus} from "../../utils/statusDict";

    export default {
        name: "taskDetail",
        components:{taskDetailCom, taskDetailComItem, taskDetailTranslatorFileListItem},
        data(){
            return{
                detailData: "",
                display: false,
                jobStatus:jobStatus()
            }
        },
        methods:{
            async getTaskInfoEvent(taskType, taskId){
                await jobDetail(taskType, taskId)
                    .then(res=>{
                        this.detailData = res;
                        this.display = true;
                    })
                    .catch(error=>{
                        console.log(error)
                    })
            },
        },
        created() {
            // 获取路由中的参数
            let taskType = this.$route.query.task_type;
            let taskId = this.$route.query.task_id;
            if(taskId&&taskType){
                // 获取详情数据
                this.getTaskInfoEvent(taskType, taskId)
            }else {
                this.$message.error("您访问的路径有误，正在为您返回")
                setTimeout(()=>{
                    this.$router.back()
                }, 1000)
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/taskPublic/taskDetail.scss";
</style>